module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reset":"Reset","search":"Search"},"si":{"reset":"Reset","search":"Search"},"ta":{"reset":"Reset","search":"Search"}}')
  delete Component.options._Ctor
}
